import Landing from './pages/Landing';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Inspectors from './pages/Inspectors';
import Properties from './pages/Properties';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import Photos from './pages/Photos';
import ResetPassword from './pages/ResetPassword';
import __Layout from './Layout.jsx';


export const PAGES = {
    "Landing": Landing,
    "Home": Home,
    "Dashboard": Dashboard,
    "Inspectors": Inspectors,
    "Properties": Properties,
    "Jobs": Jobs,
    "JobDetail": JobDetail,
    "Photos": Photos,
    "ResetPassword": ResetPassword,
}

export const pagesConfig = {
    mainPage: "Landing",
    Pages: PAGES,
    Layout: __Layout,
};